import {
  mdiClockTimeFourOutline,
  mdiGestureTap,
  mdiGestureTapHold,
  mdiMapMarkerRadiusOutline,
  mdiMotionSensor,
  mdiNfcVariant,
  mdiSync,
  mdiTimerOutline,
  mdiWeatherSunset,
  mdiWhiteBalanceSunny,
} from "@mdi/js";
import ThemeColor from "../assets/theme/ThemeColor";

// Icon and card colour for each kind of automation, as the app's
// app/screens/Automation/look.js: the Quick Actions card colours.
export const CARD_COLORS = ThemeColor.quickActions;
const [RED, GREEN, BLUE] = CARD_COLORS;

export const TYPE_LOOK = {
  tap: { icon: mdiGestureTap, color: BLUE },
  schedule: { icon: mdiClockTimeFourOutline, color: RED },
  timer: { icon: mdiTimerOutline, color: BLUE },
  sun: { icon: mdiWhiteBalanceSunny, color: GREEN },
  rule: { icon: mdiMotionSensor, color: GREEN },
  location: { icon: mdiMapMarkerRadiusOutline, color: GREEN },
  nfc: { icon: mdiNfcVariant, color: RED },
  inching: { icon: mdiGestureTapHold, color: BLUE },
  cycling: { icon: mdiSync, color: BLUE },
};

export function lookOf(automation) {
  const look = TYPE_LOOK[automation?.type] || TYPE_LOOK.tap;
  if (automation?.type === "sun" && automation.trigger?.event === "sunset") return { ...look, icon: mdiWeatherSunset };
  return look;
}

// The status pill next to an automation's name, if any: { text, tone }.
export function pillOf(automation) {
  if (automation.status === "review") return { text: "Review", tone: "warning" };
  if (automation.status === "paused") return { text: "Paused", tone: "grey" };
  if (automation.status === "done") return { text: "Done", tone: "grey" };
  if (automation.runsOn === "device" || automation.readOnly) return { text: "On device", tone: null };
  return null;
}

// Coloured while it can run on its own (tap-to-run ones always); plain when
// off, paused or done.
export const isColoured = (automation) =>
  automation.status === "active" && (automation.type === "tap" || automation.enabled !== false);
